export const FILTERS_DROPDOWN_WIDTH = 320
